import Vue from "vue";
import Course from "@/models/Course";

export default class CourseApi {

    constructor(api) {
        this.api = api;
    }

    get(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("course/" + id).then((response) => {
                callback(new Course(response.data));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    getAll(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("course").then((response) => {
                console.log(response)
                callback(response.data.map((date) => new Course(date)));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    update(data, callback, error) {
        this.api.getRaw((axios) => {
            axios.put("course/" + data.id, data).then((response) => {
                callback(new Course(response.data));
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    create(data, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("course", data).then((response) => {
                callback(new Course(response.data));
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    delete(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.delete("course/" + id).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    getPurgePreview(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("course/" + id + "/purge-preview").then((response) => {
                callback(response.data);
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    purge(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("course/" + id + "/purge").then((response) => {
                callback(response.data);
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

}
